import { render, staticRenderFns } from "./previewHelpCenter.vue?vue&type=template&id=6afac1e2&scoped=true"
import script from "./previewHelpCenter.vue?vue&type=script&lang=js"
export * from "./previewHelpCenter.vue?vue&type=script&lang=js"
import style0 from "./previewHelpCenter.vue?vue&type=style&index=0&id=6afac1e2&prod&lang=css"
import style1 from "./previewHelpCenter.vue?vue&type=style&index=1&id=6afac1e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afac1e2",
  null
  
)

export default component.exports